<template>
  <div>
    <p class="title">
      {{ $t('account.resetPassword') }}
    </p>

    <el-form
      ref="form"
      label-width="80px"
      size="medium"
      :model="form"
      :rules="rules"
    >
      <el-form-item :label="$t('account.password')" prop="pwd">
        <el-input
          v-model="form.pwd"
          type="password"
          :placeholder="$t('account.passwordPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('account.confirmPassword')" prop="pwdAgain">
        <el-input
          v-model="form.pwdAgain"
          type="password"
          :placeholder="$t('account.passwordAgainPlaceholder')"
        ></el-input>
      </el-form-item>
      <el-button
        :loading="loading"
        type="primary"
        class="sub-btn"
        @click="handleSubmit"
      >
        {{ $t('account.submit') }}
      </el-button>
    </el-form>

    <p class="err-msg" v-if="errMsg">
      {{ errMsg }}
    </p>
  </div>
</template>

<script>
import { validatorPwd, createValidatorPwdAgain, getErrorCode, getDefaultErrorText } from './mixin'
import authService from '@/api/auth'

export default {
  name: 'ResetPwd',
  data() {
    const validatorPwdAgain = createValidatorPwdAgain(this, 'form.pwd')
    return {
      email: '',
      token: '',
      time: '',

      loading: false,
      errMsg: '',

      form: {
        pwd: '',
        pwdAgain: ''
      },
      rules: {
        pwd: [
          { required: true, message: this.$t('account.passwordPlaceholder'), trigger: 'blur' },

          {
            validator: validatorPwd, trigger: 'blur'
          }
        ],
        pwdAgain: [
          { required: true, message: this.$t('account.passwordPlaceholder'), trigger: 'blur' },

          {
            validator: validatorPwdAgain, trigger: 'blur'
          }
        ]
      }
    }
  },

  beforeRouteEnter(to, from, next) {
    const { email, time, token } = to.query

    if (email && time && token) {
      next()
    } else {
      next('/')
    }
  },

  created() {
    const { email, time, token } = this.$route.query
    this.email = email
    this.time = time
    this.token = token
    this.$router.replace({ query: {} })
  },

  methods: {
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      this.loading = true
      this.errMsg = ''

      const data = {
        email: this.email,
        password: this.form.pwd,
        token: this.token,
        time: this.time
      }

      try {
        const { code } = await authService.resetPassword(data)
        if (code === 200) {
          this.$refs.form.resetFields()
        } else {
          this.errMsg = getErrorCode()[code]
          return
        }
      } catch (e) {
        this.errMsg = getDefaultErrorText()
        return
      } finally {
        this.loading = false
      }

      try {
        await this.$msgbox({
          center: true,
          message: <p class="tip">
            <i class="el-icon-success icon-success"/>{ this.$t('account.resetSuccessMessage') }
          </p>,
          confirmButtonText: this.$t('account.confirm'),
        })
        this.$router.push({ name: 'homePage' })
        this.$nextTick(() => {
          this.$store.commit('login', true)
        })
      } catch (e) {
        //
      }
    }
  }
}
</script>

<style scoped>
.tip {
  margin-top: 20px;
}

.icon-success {
  font-size: 30px;
  color: #67C23A;
  margin-right: 10px;
  vertical-align: middle;
}
</style>
